import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const FavoritesTranslations = wrapTranslationsSchema({
	name: 'FavoritesTranslations',
	title: 'Favorites Translations',
	sanityId: 'favorites',
	fields: {
		addToFavorites: 'Add to favorites',
		removeFromFavorites: 'Remove from favorites?',
		removeFromFavoritesPrompt: 'Are you sure you want to delete this item from Favorites?',
		emptyMessage: 'You have no favourites yet.',
		sortingByTitle: 'Title',
		sortingByDate: 'Date modified',
		sortingAsc: 'Ascending',
		sortingDesc: 'Descending',
		favoritesTitle: 'Favorites',
		myFavoritesOtherFavorites: 'Other',
		goToStore: 'Go to Store',
		suppliers: 'Suppliers',
		buyeasy: 'BuyEasy@Takeda',
		subStores: 'Sub-Stores',
		services: 'Services',
		goods: 'Goods',
		consultingServices: 'Services',
		digitalServices: 'Digital',
		catalogs: 'Catalogs',
		solutions: 'Solutions',
		categories: 'Categories',
		bundles: 'Bundles',
		processes: 'Processes',
		// Even though we display subcategories, they are labelled "Categories" in the designs.
		subcategories: 'Categories',
		offerings: 'Offerings',
		collections: 'Collections',
		concepts: 'Concepts',
		products: 'Products',
		purchaseOrCheckTprm: 'Purchase/Check TPRM',
		catalog: 'Catalog',
		category: 'Category',
		titleSupplier: 'Start Building your Favorites',
		titleSubcategory: 'Your categories will appear here',
		titleProduct: 'Your products will appear here',
		titleStoreOffering: 'Your store offerings will appear here',
		titleCatalog: 'Your catalogs will appear here',
		titleConcept: 'Your concepts will appear here',
		descriptionSupplier:
			'Save your most frequently used suppliers here for quicker access and smoother workflow. Favorites help you stay organized and efficient.',
		descriptionSubcategory:
			"Easily access your frequently used categories by adding them to your favorites. It's a simple way to keep your favorites close",
		descriptionProduct:
			'Easily access your frequently used products by adding them to your favorites.',
		descriptionStoreOffering:
			'Easily access your frequently used store offerings by adding them to your favorites.',
		descriptionConcept:
			'Easily access your frequently used concepts by adding them to your favorites.',
		descriptionCatalog:
			'Easily access your frequently used catalogs by adding them to your favorites.',
		searchCatalog: 'Search catalogs',
		searchSupplier: 'Search suppliers',
		searchSubcategory: 'Search categories',
		searchProduct: 'Search products',
		searchStoreOffering: 'Search store offerings',
		searchConcept: 'Search concepts',
	},
});
